import { isNotDefined } from '@/utils/lib/CheckUtils';

export function setDomElementAttribute(selector: string, attributeName: string, value: string): void {
  const tag = document.querySelector(selector);
  if (isNotDefined(tag)) throw new Error(`Tag "${tag}" is not found`);
  tag.setAttribute(attributeName, value);
}
